import * as React from "react";
import type { SVGProps } from "react";
const SvgWorksflows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M35.876 48.922a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-26a1 1 0 0 1-1-1v-14Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M37.626 49.672v12.5h24.5v-12.5h-24.5Zm-.75-1.75a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1h-26Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.245 51.865c.422.237.571.77.334 1.192l-4.007 7.124-3.539-2.528a.875.875 0 1 1 1.018-1.424l1.951 1.395 3.052-5.425a.875.875 0 0 1 1.191-.334ZM36.793 9.738h-8.2v-1.75h8.2a3.875 3.875 0 0 1 3.875 3.875v9h-1.75v-9a2.125 2.125 0 0 0-2.125-2.125Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M35.807 17.14a.875.875 0 0 1 1.237 0l2.749 2.748 2.748-2.748a.875.875 0 1 1 1.238 1.238l-3.986 3.985-3.986-3.985a.875.875 0 0 1 0-1.238ZM53.136 33.197h-8.2v-1.75h8.2a3.875 3.875 0 0 1 3.874 3.875v9h-1.75v-9a2.125 2.125 0 0 0-2.124-2.125Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M52.15 41.217a.875.875 0 0 1 1.237 0l2.748 2.748 2.749-2.748a.875.875 0 0 1 1.237 1.238l-3.986 3.985-3.985-3.985a.875.875 0 0 1 0-1.238Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M3.796 6.229c0-.69.56-1.25 1.25-1.25h9.974a1.25 1.25 0 1 1 0 2.5H5.046c-.69 0-1.25-.56-1.25-1.25ZM19.002 6.229c0-.69.56-1.25 1.25-1.25h3.666a1.25 1.25 0 1 1 0 2.5h-3.666c-.69 0-1.25-.56-1.25-1.25ZM3.796 10.729c0-.69.56-1.25 1.25-1.25h9.974a1.25 1.25 0 1 1 0 2.5H5.046c-.69 0-1.25-.56-1.25-1.25ZM19.002 10.729c0-.69.56-1.25 1.25-1.25h3.666a1.25 1.25 0 1 1 0 2.5h-3.666c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M1.874 1.829v13.3h25.3v-13.3h-25.3Zm-.75-1.75a1 1 0 0 0-1 1v14.8a1 1 0 0 0 1 1h26.8a1 1 0 0 0 1-1v-14.8a1 1 0 0 0-1-1h-26.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M21.196 29.829c0-.69.56-1.25 1.25-1.25h9.975a1.25 1.25 0 0 1 0 2.5h-9.975c-.69 0-1.25-.56-1.25-1.25ZM36.402 29.829c0-.69.56-1.25 1.25-1.25h3.667a1.25 1.25 0 0 1 0 2.5h-3.667c-.69 0-1.25-.56-1.25-1.25ZM21.196 34.329c0-.69.56-1.25 1.25-1.25h9.975a1.25 1.25 0 0 1 0 2.5h-9.975c-.69 0-1.25-.56-1.25-1.25ZM36.402 34.329c0-.69.56-1.25 1.25-1.25h3.667a1.25 1.25 0 0 1 0 2.5h-3.667c-.69 0-1.25-.56-1.25-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M19.226 25.271v13.3h25.3v-13.3h-25.3Zm-.75-1.75a1 1 0 0 0-1 1v14.8a1 1 0 0 0 1 1h26.8a1 1 0 0 0 1-1v-14.8a1 1 0 0 0-1-1h-26.8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWorksflows;
